<div #divcontainer>
	<div class="content">

		<h2 [translate]="'widgets.teamMood.newEnterVote'">Entver vote</h2>
		<!-- Person -->
		<div class="card-field person-dropzone teamwidgetdropzone" [attr.data-voting-id]="1">
			<div class="content-none-person" *ngIf="!vote.person">
					<mat-icon aria-hidden="false" >account_circle</mat-icon>
					<p>Anonymous</p>
			</div>
			<div class="content-selected" *ngIf="vote.person">
				<img class="avatar" [src]="'data:image/png;base64,'+ vote.person.avatarImage">
				<p>{{vote.person.displayName}}</p>
			</div>
		</div>

		<div class="container-hr">
			<div class="line-hr"><mat-divider></mat-divider></div>
			<div class="text-hr mat-typography">
				<button class="button-removePerson" *ngIf="vote.person"  (click)="removePerson()">
					<mat-icon>cancel</mat-icon>
				</button>
				<div class="line-hr" *ngIf="!vote.person"><mat-divider></mat-divider></div>
			</div>
			<div class="line-hr">
			  <mat-divider></mat-divider>
			</div>
		</div>


		<!-- Question -->
		<div *ngIf="vote">
			<div *ngIf="vote.ratings.length > 0">
				<div *ngFor="let q of vote.ratings">
				<label>{{q.question.name}}</label>
				<!-- TODO move colors and size to .scss file -->
				<star-rating id="{{q.question.id}}" [value]="0" [totalstars]="5" checkedcolor="gold" uncheckedcolor="grey" size="36px" readonly="false" (rate)="onClick($event, q)"></star-rating>
				</div>
			</div>


			<div>
			<!-- Comment -->
			<div>
				<textarea matInput placeholder="{{placeholderComment}}" class="textarea-comment" [(ngModel)]="vote.comment"></textarea>
			</div>

			<!-- Vote Button -->
			<div>
				<button mat-mini-fab color="accent" type="button" class="btn btn-success" (click)="submitVote()" [translate]="'widgets.teamMood.vote'">
					<mat-icon aria-hidden="false" >done</mat-icon>
				</button>
				<button mat-mini-fab color="clear"  type="button" (click)="cancelVote()" [translate]="'widgets.teamMood.cancelVote'">
					<mat-icon aria-hidden="false" >clear</mat-icon>
				</button>
			</div>
			</div>
		</div>
	</div>
</div>
